import type * as Blockly from 'blockly/core';
import { BOARD_CONFIG } from '@/(routers)/boards/editor/block/blockConfig';
import { registerSetupCode, resolveBoard, stmt } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

type Position = keyof (typeof BOARD_CONFIG)[keyof typeof BOARD_CONFIG]['pins'];

export const sevenSegHelperCode =
    `void dispInt(TM1637Display numDisplay, float f) {\n` +
    `  int num = (int)f;\n` +
    `  numDisplay.showNumberDecEx(num, 0x0, false);\n` +
    `}\n` +
    `void dispFloat(TM1637Display numDisplay, float f) {\n` +
    `  int num = (int)round(f * 10);\n` +
    `  numDisplay.showNumberDecEx(num, 0b00100000, false);\n` +
    `}\n` +
    `void dispBlank(TM1637Display numDisplay) {\n` +
    `  uint8_t SEG_BLANK[] = {0,0,0,0};\n` +
    `  numDisplay.setSegments(SEG_BLANK);\n` +
    `}\n`;

export const sevenSegGlobalCodes = new Map<string, string>();

let _used = false;

export function sevenSegUsed(): boolean {
    return _used;
}

export function sevenSegMarkUsed(): void {
    _used = true;
}

export function resetSevenSeg(): void {
    _used = false;
    sevenSegGlobalCodes.clear();
}

export function register(gen: any): void {
    gen.forBlock['seven_seg_number'] = function (block: Blockly.Block): string {
        const position = block.getFieldValue('POSITION') as Position;
        const mode = block.getFieldValue('MODE') as 'INT' | 'FLOAT';
        const board = resolveBoard(block);
        const pins = BOARD_CONFIG[board].pins[position];
        const clk = pins.first;
        const dio = pins.second;
        const key = `${clk}_${dio}`;
        const instanceName = `num_display_${clk}_${dio}`;

        if (!sevenSegGlobalCodes.has(key)) {
            sevenSegGlobalCodes.set(key, `TM1637Display ${instanceName}(${clk}, ${dio});\n`);
            registerSetupCode(key, `  ${instanceName}.setBrightness(0x0f);\n`);
        }

        const value = gen.valueToCode(block, 'VALUE', 0) || '0';
        sevenSegMarkUsed();

        if (mode === 'FLOAT') {
            const clampedValue = `constrain(${value}, -99.9, 999.9)`;
            return stmt(`dispFloat(${instanceName}, ${clampedValue})`);
        } else {
            const clampedValue = `constrain(${value}, -999, 9999)`;
            return stmt(`dispInt(${instanceName}, ${clampedValue})`);
        }
    };
}
